import { FormField, SectionExpandable, Toggle } from "@prequel/shared-components";

import { MagicLink } from "@/types";

type AdvancedOptionsProps = {
  link: MagicLink;
  setLinkField: (key: keyof MagicLink, value: string | string[] | boolean) => void;
  disabled: boolean;
};
const AdvancedOptions = ({ link, setLinkField, disabled }: AdvancedOptionsProps) => {
  return (
    <SectionExpandable label="Advanced options">
      <div className="space-y-4">
        <Toggle
          label="Enable destination automatically"
          subtext={"Connection will be created as \"enabled\" and data will begin transferring upon successful link submission."} // prettier-ignore
          checked={link.set_destination_enabled}
          setChecked={(enabled: boolean) => setLinkField("set_destination_enabled", enabled)}
          disabled={disabled}
        />
        <FormField
          label="Redirect URL"
          id="redirect_url"
          type="url"
          pattern="https?://.*"
          patternComment="URL must start with http:// or https://"
          subtext="If provided, the user will be redirected to the provided URL after successful form submission. If left blank, the user will remain on the successful submission page."
          value={link.redirect_url}
          onChangeHandler={(value: string) => setLinkField("redirect_url", value)}
          disabled={disabled}
        />
      </div>
    </SectionExpandable>
  );
};

export default AdvancedOptions;
